/* eslint-disable vue/one-component-per-file */
import { createApp, h } from 'vue';
import DateField from '@/components/input/DateField.vue';
import YearMonthPicker from '@/corePagesModule/components/YearMonthPicker.vue';

/**
 * モーダルで使う用：DateFieldを返す
 * @param propDate - DateFieldの初期値
 * @param propIsModal - DateFieldがモーダル内にあるかどうか
 * @param bindingFunc - DateFieldの値が変更されたときに実行する関数
 * @param useDisabledDates - 選択制限を使用するかどうか
 */
export const dateField = (
  propDate: Date,
  propIsModal: boolean,
  bindingFunc: (date: Date) => void,
  useDisabledDates?: ((date: Date) => boolean) | Date[]
) => {
  return createApp({
    // eslint-disable-next-line jsdoc/require-jsdoc
    data() {
      return {
        date: propDate,
      };
    },
    // eslint-disable-next-line jsdoc/require-jsdoc
    render() {
      return h(DateField, {
        'input-date': this.date,
        'is-modal': propIsModal,
        'disabled-dates': useDisabledDates,
        // eslint-disable-next-line jsdoc/require-jsdoc
        onChangeValue: ($event) => {
          this.date = $event;
          console.log('変更後の日付', this.date);
          bindingFunc($event);
        },
      });
    },
  });
};

/**
 * モーダルで使う用：DateFieldを返す
 * @param propDate - 日付の初期値
 * @param bindingFunc - 日付が変更されたときに実行する関数
 */
export const yearMonthSelect = (propDate: Date, bindingFunc: (date: Date) => void) => {
  return createApp({
    // eslint-disable-next-line jsdoc/require-jsdoc
    data() {
      return {
        date: propDate,
      };
    },
    // eslint-disable-next-line jsdoc/require-jsdoc
    render() {
      return h(YearMonthPicker, {
        'input-date': this.date,
        // eslint-disable-next-line jsdoc/require-jsdoc
        onChangeValue: ($event) => {
          this.date = $event;
          bindingFunc($event);
        },
      });
    },
  });
};
